const schema = process.env.REACT_APP_SCHEMA
export default schema